import DefaultButton from "../default.button";
import useSendPasswordReset from "../../../hooks/users/useSendPasswordReset.user.hook";

const ResetPasswordButton = ({ onClick = () => null, email = "" }) => {
  const { sendPasswordReset } = useSendPasswordReset();
  const handleClick = (event) => {
    event.preventDefault();
    onClick();
    sendPasswordReset(email);
  };
  return (
    <DefaultButton handleClick={handleClick}>Reset Password</DefaultButton>
  );
};

export default ResetPasswordButton;
